<div class="main-column">
    <div class="author-profile">
        <div class="author-loading" *ngIf="authorLoading && !authorError">
          	Loading...
        </div>
        <div class="author-loading" *ngIf="authorError">
			<!-- <span>
				Sorry, this author could not be loaded.
				Please <span class="retry-link" (click)="getAuthorInfo()">try again</span>.
			</span> -->
        </div>
        <!-- <div class="author-image" *ngIf="!authorLoading && !authorError">
			<picture *ngIf="author.thumbnail?.dynamic_url">
				<source [srcset]="author.thumbnail.dynamic_url + '?w=120&fm=webp'" type="image/webp">
				<source [srcset]="author.thumbnail.dynamic_url + '?w=120'" [type]="author.thumbnail.mime_type">
				<img [alt]="author.thumbnail.custom_properties.alt_text"
					[src]="author.thumbnail.dynamic_url + '?w=120'" class="book-image" loading="lazy">
			</picture>
        </div> -->
        <div class="author-text" *ngIf="!authorLoading && !authorError">
			<h1 class="author-name">{{ author.first_name }} {{ author.last_name }}</h1>
			<div class="author-bio" [innerHtml]="author.description"></div>
        </div>
	</div>
	<ng-container *ngIf="!authorLoading && !authorError">
		<div class="article-list-heading">
			<div class="list-title">
				All Articles by {{ author.first_name }}
			</div>

			<a class="authors-link" routerLink="/news/authors">
				More Writers <fa-icon class="more-icon" [icon]="faChevronRight"></fa-icon>
			</a>
		</div>
		<app-article-list
			[author]="author.id"
			[authorMode]="true"
			[authorName]="author.first_name + ' ' + author.last_name"
			[currentPage]="pageNumber"
			[nextPageURL]="nextPageURL"
		></app-article-list>
	</ng-container>

	<app-best-offers *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
	<app-display-ad type="main-column" *ngIf="environment.googleAdsConfig?.adSpaces?.['main-column'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
</div>
<div class="sidebar">
	<app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
    <app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
    <app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<!-- <app-latest-articles-list></app-latest-articles-list>
	<app-futures-snapshot *ngIf="environment.availableSports.length > 0"></app-futures-snapshot>
	<app-contributor-summary></app-contributor-summary> -->
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>